const root = 'lapidary-single-select'

export const singleSelectClasses = {
  root,
  label: `${root}-label`,
  menu: `${root}-menu`,
  footer: `${root}-menu-footer`,
  menuItem: `${root}-menu-item`,
  search: `${root}-search-bar`,
  trigger: `${root}-trigger`,
  triggerText: `${root}-trigger-text`,
}
